import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import ResultsPage from './pages/ResultsPage'
import ScanningPage from './pages/ScanningPage'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="scan/:scanId" element={<ScanningPage />} />
        <Route path="results/:scanId" element={<ResultsPage />} />
      </Route>
    </Routes>
  )
}
